var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"contentblocks",class:{
    'contentblocks--has-backgroundcolor': _vm.hasBackgroundColor,
    layout__content: !_vm.hasBackgroundColor,
    'contentblocks--multinational': _vm.multinational,
  }},[_c('div',{staticClass:"contentblocks-wrapper columns"},_vm._l((_vm.blocks),function(block,index){return _c('div',{key:index,staticClass:"column",class:{
        layout__content: _vm.hasLayoutContent,
        'is-half': block.type === 'dashboardcalltoaction',
        'is-full': block.type !== 'dashboardcalltoaction',
        'column--no-top-margin': _vm.noTopMargin,
      }},[_c(`${block.type}Block`,{tag:"Component",attrs:{"block":block}})],1)}),0),(_vm.pages)?_c('div',{class:{ layout__content: _vm.hasLayoutContent }},[_c('pagesblock',{tag:"Component",attrs:{"pages":_vm.pages}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }